import styled from 'styled-components'
import { theme } from '../../../style/theme'
import { colorTheme } from '../../../style/theme/colorTheme'

export const PickupMonitorOrdersWrap = styled.div`
	font-size: 1rem;
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	position: relative;
	width: 100%;

	&.toggled {
		grid-template-columns: 1fr 0.685fr;
	}

	@media screen and (max-width: ${theme.point1280}) {
		&.toggled {
			grid-template-columns: repeat(2, 1fr);
		}
	}

	@media screen and (max-width: ${theme.point820}) {
		grid-template-columns: 1fr;

		&.toggled {
			grid-template-columns: 1fr;
		}
	}
`
PickupMonitorOrdersWrap.displayName = 'PickupMonitorOrdersWrap'

export const PickupMonitorOrdersContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1.88em;
	padding-right: 1.25em;
	padding-bottom: 4.19em;

	&.processing-pickup {
		padding-left: 1.25em;
		border-left: 1px dashed ${colorTheme.pickupMonitor.border};
	}

	@media screen and (max-width: ${theme.point820}) {
		padding-right: 0;

		&.processing-pickup {
			padding-left: 0;
			border-left: none;
		}
	}
`
PickupMonitorOrdersContent.displayName = 'PickupMonitorOrdersContent'

export const PickupMonitorOrdersTitle = styled.div`
	display: flex;
	align-items: center;
	gap: 0.63em;

	> svg {
		width: 100%;
		height: 100%;
		flex-shrink: 0;

		&.clock {
			width: 1.56em;
			height: 1.56em;
			fill: ${colorTheme.pickupMonitor.title.awaitingIcon};
		}

		&.clipboard {
			width: 1.38em;
			height: 1.56em;
			fill: ${colorTheme.pickupMonitor.title.processingIcon};
		}
	}
`
PickupMonitorOrdersTitle.displayName = 'PickupMonitorOrdersTitle'

export const PickupMonitorOrdersTitleTextBlock = styled.div`
	display: flex;
	align-items: center;
	gap: 0.31em;
`
PickupMonitorOrdersTitleTextBlock.displayName = 'PickupMonitorOrdersTitleTextBlock'

export const PickupMonitorOrdersTitleText = styled.div`
	color: ${colorTheme.pickupMonitor.title.text};
	font-family: ${theme.fontRobotoBold};
	font-size: 1.5em;
	font-weight: 700;
	text-transform: uppercase;
`
PickupMonitorOrdersTitleText.displayName = 'PickupMonitorOrdersTitleText'

export const PickupMonitorOrdersCards = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(max-content, 20.63em));
	gap: 1.44em;
	transition: all 0.2s ease-in-out;

	&.toggled-awaiting-pickup {
		grid-template-columns: repeat(3, minmax(max-content, 20.63em));
	}

	@media screen and (max-width: ${theme.point1280}) {
		grid-template-columns: 1fr;
		width: 100%;

		&.toggled, &.toggled-awaiting-pickup {
			grid-template-columns: repeat(2, minmax(max-content, 20.63em));
			width: max-content;
		}
	}

	@media screen and (max-width: ${theme.point1024}) {
		&.toggled, &.toggled-awaiting-pickup {
			grid-template-columns: 1fr;
			width: 100%;
		}
	}

	@media screen and (max-width: ${theme.point820}) {
		&.toggled, &.toggled-awaiting-pickup {
			grid-template-columns: 1fr 1fr;
			width: 100%;
			gap: 1.43em 0.72em;
		}
	}

	@media screen and (max-width: ${theme.point720}) {
		&.toggled, &.toggled-awaiting-pickup {
			grid-template-columns: 1fr;
			width: 100%;
			gap: 0.63em;
		}
	}
`
PickupMonitorOrdersCards.displayName = 'PickupMonitorOrdersCards'
